import { Center } from "@/components/standard/BFLayout"
import { Body, H2, H3, H4, HDisplay } from "@/components/standard/BFText"
import { SaveOnFutureDeals } from "@/screens/rewards/components/SaveOnFutureDeals"
import { Pressable, ScrollView } from "react-native"
import { useUser } from "@/queries/user"
import { StartALoanButton } from "@/screens/rewards/components/StartALoanButton"
import { AllRewards } from "@/screens/rewards/components/AllRewards"
import { AvailableRewards } from "@/components/AvailableRewards"

export const RewardsTab = ({ setTab }: { setTab: (tab: string) => void }) => {
  const { data: user } = useUser()

  const balance = user?.me?.lastPointTransaction?.balance || 0

  if (balance === 0) {
    return (
      <ScrollView className={"bg-grey flex-1 px-5"}>
        <Center className={"p-10 flex-col"}>
          <H2 className={"text-midnight-blue mb-1"}>Save as You Grow</H2>
          <Body className={"text-midnight-blue"}>
            Close your first deal with Backflip to start earning discounts on
            future deals
          </Body>
        </Center>
        <AllRewards />
        <StartALoanButton />
      </ScrollView>
    )
  }

  return (
    <ScrollView className={"bg-off-white flex-1 px-5"}>
      <Center className={"p-10 flex-col"}>
        <HDisplay className={"text-midnight-blue"}>
          {balance.toLocaleString("en-US", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
          })}
        </HDisplay>
        <Body className={"text-midnight-blue"}>Available Points</Body>
      </Center>

      <AvailableRewards>
        <>
          <H3 className={"text-midnight-blue mb-4"}>Your Discount</H3>
        </>
      </AvailableRewards>

      <StartALoanButton />

      <SaveOnFutureDeals />

      <Pressable
        testID={"full-program-details-button"}
        onPress={() => {
          setTab("points")
        }}
      >
        <Center className={"m-5 mb-10"}>
          <H4 className={"text-calm-blue underline"}>
            How to Earn More Points
          </H4>
        </Center>
      </Pressable>
    </ScrollView>
  )
}
